import React from 'react'
import { ThemeProvider } from '@emotion/react'
import { Leva } from 'leva'
import ReactDOM from 'react-dom/client'
import 'antd/dist/antd.min.css'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import theme from './theme'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  /* <React.StrictMode> */
  <ThemeProvider theme={theme}>
    <div className={'leva'}>
      <Leva hidden={process.env.NODE_ENV === 'production'} />
    </div>
    <App />
  </ThemeProvider>
  /* </React.StrictMode> */
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
